import React from 'react';

import { SVGProps } from './type';

function Icon(props: SVGProps) {
  const { size = 24, color = '#095CAA' } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M7.706 9.092h-4.5v-4.5"
      />
      <path
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M15.385 19.367A8.25 8.25 0 106.394 5.915L3.206 9.092"
      />
      <path
        fill={color}
        fillRule="evenodd"
        d="M12.207 12.293a1 1 0 010 1.414l-4.5 4.5a1 1 0 01-1.414 0l-2-2a1 1 0 111.414-1.414L7 16.086l3.793-3.793a1 1 0 011.414 0z"
        clipRule="evenodd"
      />
    </svg>
  );
}

export default Icon;
